import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Injectable()
export class DateService {

    private pipe: DatePipe = new DatePipe('pt-BR');
    private now = Date.now();

    getTodayValue(): string {
        let date = this.pipe.transform(this.now, 'dd/MM/yyyy');

        return date;
    }

    // DATA Convertions
    splitDateFromDateTime(someDate: string) {
        let splittedDate = someDate.split(' ', 1)[0];
        return splittedDate;
    }

    formGroupToString(someDate: { year?: number, month: number, day: number }): string {
        let date: string;

        if ((someDate.year > 0) && (someDate.month > 0) && (someDate.day > 0)) {

            let day = someDate.day < 10 ? `0${someDate.day}` : `${someDate.day}`;
            let month = someDate.month < 10 ? `0${someDate.month}` : `${someDate.month}`;
            let year = someDate.year < 1000 ? `0${someDate.year}` : `${someDate.year}`;

            date = `${day}/${month}/${year}`;

        } else if ((someDate.month > 0) && (someDate.day > 0) && (someDate.year === undefined)) {

            let day = someDate.day < 10 ? `0${someDate.day}` : `${someDate.day}`;
            let month = someDate.month < 10 ? `0${someDate.month}` : `${someDate.month}`;

            date = `${day}/${month}`;

        } else {

            date = undefined;
        }

        return date;
    }

    // SET TO FORMGROUP
    // TODO Refactor mudar para AbstractControl o parâmetro
    setTodayValue(formGroup, formGroupFieldName: string) {

        let date = this.pipe.transform(this.now, 'dd/MM/yyyy');

        let value = { year: parseInt(date.substr(6, 4)), month: parseInt(date.substr(3, 2)), day: parseInt(date.substr(0, 2)) };

        formGroup.get(formGroupFieldName).setValue(value);
    }

    setFirstDayValue(formControl: AbstractControl) {

        let newDate = new Date();
        let firstDay = new Date(newDate.getFullYear(), newDate.getMonth(), 1);

        let date = this.pipe.transform(firstDay, 'dd/MM/yyyy');

        let value = { year: parseInt(date.substr(6, 4)), month: parseInt(date.substr(3, 2)), day: parseInt(date.substr(0, 2)) };

        formControl.setValue(value);
    }

    setLastDayValue(formControl: AbstractControl) {

        let newdate = new Date();
        let lastDay = new Date(newdate.getFullYear(), newdate.getMonth() + 1, 0);

        let date = (this.pipe.transform(lastDay, 'dd/MM/yyyy'));

        let value = { year: parseInt(date.substr(6, 4)), month: parseInt(date.substr(3, 2)), day: parseInt(date.substr(0, 2)) };

        formControl.setValue(value);
    }

    setValue(formGroup, formGroupFieldName: string, valueToSubtractFromToday: number) {

        let result: Date = new Date();
        result.setDate(result.getDate() - valueToSubtractFromToday);

        let date = this.pipe.transform(result, 'dd/MM/yyyy');

        let value = { year: parseInt(date.substr(6, 4)), month: parseInt(date.substr(3, 2)), day: parseInt(date.substr(0, 2)) };

        formGroup.get(formGroupFieldName).setValue(value);
    }

    // DATA Validations
    isValid(someDate: { year: number, month: number, day: number }): boolean {
        if (someDate !== undefined && someDate !== null) {
            if (someDate.year == null || someDate.year < 1800 || someDate.year > 3000) {
                return false;
            } else if (someDate.month == null || someDate.month <= 0 || someDate.month > 12) {
                return false;
            } else if (someDate.day == null || someDate.day <= 0 || someDate.day > 31) {
                return false;
            }
            return true;
        } else {
            return false;
        }
    }

    isPeriodValid(formControlInitialDate: AbstractControl, formControlFinalDate: AbstractControl): boolean {
        let valid = false;

        if (formControlInitialDate.value === null || formControlFinalDate.value === null) {
            valid = false;
        } else {
            if (typeof (formControlInitialDate.value) === 'object' && typeof (formControlFinalDate.value) === 'object') {
                let initialDate = formControlInitialDate.value;
                let finalDate = formControlFinalDate.value;

                valid = initialDate.year <= finalDate.year ? true : false;
                if (initialDate.year === finalDate.year) {
                    valid = initialDate.month <= finalDate.month && valid ? true : false;
                    valid = initialDate.day <= finalDate.day && valid ? true : false;
                } else {
                    return valid;
                }
            }
        }

        return valid;
    }

    public convertDateMonthFormGroupToNumberArray(control: AbstractControl): number[] {
        let controlValue: string = control.value;

        let monthsArray: string[] = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

        let splittedControlValue: string[] = controlValue ? controlValue.split('/') : null;
        let numericControlValues: number[] = [];

        if (splittedControlValue) {
            let monthIndex = monthsArray.findIndex((x) => x === splittedControlValue[0]) + 1;

            numericControlValues.push(monthIndex);
            numericControlValues.push(parseInt(splittedControlValue[1]));
        }
        
        return numericControlValues;
    }
}